import React, { useState } from 'react';
import {
    styled,
    Box,
    Stack,
    Typography,
    FormControl,
    IconButton,
    FormControlLabel,
    Grid,
    Checkbox,
    Button,
    Input,
    InputAdornment,
    //
} from '@mui/material';
import { Close, Search } from '@material-ui/icons';

const ModalWrap = styled(Box)(() => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FFFFFF',
    padding: 24,
    boxShadow: 6,
    borderRadius: 5,
    width: 720,
}));

const CheckboxWrap = styled(Box)(() => ({
    maxHeight: 300,
    overflowY: 'auto',
    backgroundColor: '#F7F8FB',
    padding: 16,
    borderRadius: 5,
}));

const SelectModal = ({ label, options, setOpenModal, selectedUsers, setSelectedUsers }) => {
    const [newSelection, setNewSelection] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const handleCheckboxChange = (optionName) => {
        setSelectedUsers((prevSelected) => {
            if (prevSelected.includes(optionName)) {
                setNewSelection((prevNew) => prevNew.filter((name) => name !== optionName));
                return prevSelected.filter((name) => name !== optionName);
            }
            setNewSelection((prevNew) => [...prevNew, optionName]);
            return [...prevSelected, optionName];
        });
    };

    const handleDeselectAll = () => {
        setSelectedUsers([]);
        setNewSelection([]);
    };

    const handleCancel = () => {
        setSelectedUsers((prevSelected) => prevSelected.filter((name) => !newSelection.includes(name)));
        setNewSelection([]);
        setOpenModal(false);
    };

    const handleApply = () => {
        setOpenModal(false);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredOptions = options.filter((option) => option.name.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <ModalWrap>
            <Stack spacing={2}>
                <Box fullWidth display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">Select {label}</Typography>
                    <IconButton onClick={() => setOpenModal(false)}>
                        <Close />
                    </IconButton>
                </Box>
                <FormControl variant="standard">
                    <Input
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        startAdornment={
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                    />
                </FormControl>
                <CheckboxWrap>
                    <Grid container spacing={2}>
                        {filteredOptions.map((option) => (
                            <Grid item xs={4} key={option._id}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedUsers.includes(option._id)}
                                            onChange={() => handleCheckboxChange(option._id)}
                                            //
                                        />
                                    }
                                    label={option.name}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </CheckboxWrap>
                <Typography variant="body2" fontWeight={600}>
                    Selected: {selectedUsers.length}/{options.length}
                </Typography>
                <Box display="flex" justifyContent="space-between">
                    <Button onClick={handleDeselectAll} variant="outlined" color="error">
                        Deselect All
                    </Button>
                    <Box>
                        <Button onClick={handleCancel} variant="outlined" color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={handleApply} variant="contained" color="primary" sx={{ ml: 2 }}>
                            Apply
                        </Button>
                    </Box>
                </Box>
            </Stack>
        </ModalWrap>
    );
};

export default SelectModal;
